import { gql } from '@apollo/client';

export const GetStudentOnlineApplicationShortQuery = gql`
    query GetStudentOnlineApplicationShort {
        getStudentOnlineApplication {
            id
            status
            active
            deadline {
                interactive
                fill
                chat
            }
        }
    }
`;
